import React, { useState, useEffect } from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';

export default function CandidateForm() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    NricId: '',
    Name: '',
    DOB: '',
    CourseID: '',   // keep as string in state
    BatchNo: '',
    Password: '',
    Mobile: '',
    Email: '',
    SerialNo: '',
  });

  const [batchCourseData, setBatchCourseData] = useState([]);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingBatchCourse, setLoadingBatchCourse] = useState(true);

  useEffect(() => {
    async function fetchBatchCourse() {
      try {
        const res = await fetch('https://elearn-api.onrender.com/api/getBatchAndCourse');
        const data = await res.json();
        setBatchCourseData(data);
      } catch (error) {
        console.error('Failed to fetch batch and course data', error);
      } finally {
        setLoadingBatchCourse(false);
      }
    }
    fetchBatchCourse();
  }, []);

  // Get all unique CourseIDs as strings (no filtering)
  const uniqueCourseIDs = [...new Set(batchCourseData.map(item => String(item.CourseID)))];

  // Get all unique BatchNos as strings (no filtering)
  const uniqueBatchNos = [...new Set(batchCourseData.map(item => String(item.BatchNo)))];

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

const handleSubmit = async e => {
  e.preventDefault();

  if (!formData.CourseID) {
    setMessage('Please select a valid Course ID.');
    return;
  }
  if (!formData.BatchNo) {
    setMessage('Please select a valid Batch No.');
    return;
  }

  setLoading(true);

  // Send CourseID as string exactly as selected
  const payload = {
    ...formData,
  };

  try {
    const res = await fetch('https://elearn-api.onrender.com/api/insertCandidate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.message || 'Failed to insert candidate');
    }

    setMessage('Candidate inserted successfully!');
    setFormData({
      NricId: '',
      Name: '',
      DOB: '',
      CourseID: '',
      BatchNo: '',
      Password: '',
      Mobile: '',
      Email: '',
      SerialNo: '',
    });
  } catch (err) {
    setMessage('Error: ' + err.message);
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="candidate-form-container">
     
      <h2>Insert Candidate</h2>
      
   <button className="view-candidates-btn"  onClick={() => navigate("/all-candidate")} >
      View Candidates
    </button>
      {loadingBatchCourse ? (
        <p>Loading batch and course data...</p>
      ) : (
        <form onSubmit={handleSubmit} className="candidate-form">

            <div className="form-group-stu">
            <label htmlFor="CourseID">Course ID</label>
            <select
              id="CourseID"
              name="CourseID"
              value={formData.CourseID}
              onChange={handleChange}
              required
              className="form-input"
            >
              <option value="">Select Course ID</option>
              {uniqueCourseIDs.map(courseId => (
                <option key={courseId} value={courseId}>
                  {courseId}
                </option>
              ))}
            </select>
          </div>

          {/* BatchNo dropdown */}
          <div className="form-group-stu">
            <label htmlFor="BatchNo">Batch No</label>
            <select
              id="BatchNo"
              name="BatchNo"
              value={formData.BatchNo}
              onChange={handleChange}
              required
              className="form-input"
            >
              <option value="">Select Batch No</option>
              {uniqueBatchNos.map(batchNo => (
                <option key={batchNo} value={batchNo}>
                  {batchNo}
                </option>
              ))}
            </select>
          </div>

          {[
            { label: 'NRIC ID', name: 'NricId', type: 'text' },
            { label: 'Name', name: 'Name', type: 'text' },
            { label: 'Date of Birth', name: 'DOB', type: 'date' },
            { label: 'Password', name: 'Password', type: 'password' },
            { label: 'Mobile', name: 'Mobile', type: 'text' },
            { label: 'Email', name: 'Email', type: 'email' },
            { label: 'Serial No', name: 'SerialNo', type: 'text' },
          ].map(({ label, name, type }) => (
            <div key={name} className="form-group-stu">
              <label htmlFor={name}>{label}</label>
              <input
                id={name}
                name={name}
                type={type}
                value={formData[name]}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
          ))}

          {/* CourseID dropdown */}
        
          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      )}

      {message && (
        <p className={`message ${message.startsWith('Error') ? 'error' : 'success'}`}>
          {message}
        </p>
      )}
    </div>
  );
}
